import { FormField, SearchField } from '@/components/custom/erp';
import { accountSearchColumns, QUERY_KEYS } from '@/constants';
import { AccountModel, TKData } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface BasicInfoTabProps {
  formMode: FormMode;
  taiKhoanNo: AccountModel | TKData | null;
  taiKhoanCo: AccountModel | TKData | null;
  setTaiKhoanNo: (taiKhoanNo: AccountModel | TKData | null) => void;
  setTaiKhoanCo: (taiKhoanCo: AccountModel | TKData | null) => void;
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({
  formMode,
  taiKhoanNo,
  taiKhoanCo,
  setTaiKhoanNo,
  setTaiKhoanCo
}) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Ngoại tệ</Label>
          <div className='w-[240px]'>
            <FormField type='text' name='ma_nt' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Tên ngoại tệ</Label>
          <div className='w-full'>
            <FormField type='text' name='ten_nt' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Tên khác</Label>
          <div className='w-full'>
            <FormField type='text' name='ten_nt2' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Tk phát sinh cl nợ</Label>
          <SearchField<AccountModel>
            type='text'
            name='tk_pscl_no'
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN_ALL}/`}
            searchColumns={accountSearchColumns}
            dialogTitle='Danh mục tài khoản'
            displayRelatedField='code'
            columnDisplay='code'
            value={taiKhoanNo?.code}
            relatedFieldValue={taiKhoanNo?.name}
            onRowSelection={setTaiKhoanNo}
            className='w-100'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Tk phát sinh cl có</Label>
          <SearchField<AccountModel>
            type='text'
            name='tk_pscl_co'
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN_ALL}/`}
            searchColumns={accountSearchColumns}
            dialogTitle='Danh mục tài khoản'
            displayRelatedField='code'
            columnDisplay='code'
            value={taiKhoanCo?.code}
            relatedFieldValue={taiKhoanCo?.name}
            onRowSelection={setTaiKhoanCo}
            className='w-100'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Stt</Label>
          <FormField type='number' name='stt' disabled={formMode === 'view'} />
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Đọc lẻ</Label>
          <FormField type='number' name='ra_ndec' disabled={formMode === 'view'} />
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Cách đọc</Label>
          <div className='flex items-center gap-2'>
            <FormField type='text' name='ra_1' disabled={formMode === 'view'} />
            <FormField type='text' name='ra_2' disabled={formMode === 'view'} />
            <FormField type='text' name='ra_3' disabled={formMode === 'view'} />
            <FormField type='text' name='ra_4' disabled={formMode === 'view'} />
            <FormField type='text' name='ra_5' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Cách đọc 2</Label>
          <div className='flex items-center gap-2'>
            <FormField type='text' name='ra_12' disabled={formMode === 'view'} />
            <FormField type='text' name='ra_22' disabled={formMode === 'view'} />
            <FormField type='text' name='ra_32' disabled={formMode === 'view'} />
            <FormField type='text' name='ra_42' disabled={formMode === 'view'} />
            <FormField type='text' name='ra_52' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Trạng thái</Label>
          <div className='w-full'>
            <FormField
              type='select'
              name='status'
              disabled={formMode === 'view'}
              options={[
                { value: '1', label: '1. Còn sử dụng' },
                { value: '0', label: '0. Không sử dụng' }
              ]}
              defaultValue='1'
            />
          </div>
        </div>
      </div>
    </div>
  );
};
